import { useAuth } from "@/components/auth/auth-context";
import { CustomTabs } from "@/components/ui/custom-tabs";
import { Escalation } from "@/lib/api/escalations";
import { MentorshipDetails } from "@/lib/api/mentorships";
import { UserRole } from "@/lib/api/user";
import { useLocation } from "@tanstack/react-router";
import { useState } from "react";
import { EscalationNote } from "./escalation-note";
import { EscalationTeenDetails } from "./escalation-teen-details";

const TABS = [
  {
    id: "info",
    label: "Info",
  },
  {
    id: "note",
    label: "Escalation Note",
  },
];

interface EscalationDetailsProps {
  mentorship: MentorshipDetails;
  escalation: Escalation;
  onClose: () => void;
}

export function EscalationDetails({
  mentorship,
  escalation,
  onClose,
}: EscalationDetailsProps) {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState("info");

  if (!mentorship || !escalation) {
    return null;
  }

  if (user?.role === UserRole.MENTOR || !pathname.includes("mentorships")) {
    return <EscalationTeenDetails mentee={mentorship.mentee} />;
  }

  return (
    <div className="px-2 py-2">
      <CustomTabs
        tabs={TABS}
        activeTab={activeTab}
        onChangeTab={setActiveTab}
      />

      {activeTab === "info" && (
        <div className="mt-4">
          <EscalationTeenDetails mentee={mentorship.mentee} />
        </div>
      )}

      {activeTab === "note" && (
        <div className="mt-4">
          <EscalationNote
            mentorship={mentorship}
            escalation={escalation}
            onClose={onClose}
          />
        </div>
      )}
    </div>
  );
}
